import { ChangeEvent, FormEvent, useState } from 'react';
import GridShape from '../../components/common/GridShape';
import Input from '../../components/form/input/InputField';
import Label from '../../components/form/Label';
import { EyeCloseIcon, EyeIcon } from '../../icons';
import Checkbox from '../../components/form/input/Checkbox';
import Button from '../../components/ui/button/Button';
import PageMeta from '../../components/common/PageMeta';
import { loginUser } from '../../services/auth';
import { useUserStore } from '../../store/userStore';
import { toast } from 'react-toastify';
import { Navigate } from 'react-router';

export default function SignIn() {
  const [showPassword, setShowPassword] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [values, setValues] = useState({
    email: '',
    password: '',
  });
  const { setUser, login } = useUserStore();
  const isLoggedIn = useUserStore().isLoggedIn;

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const res = await loginUser(values);
      setUser(res.data.user);
      login();
      localStorage.setItem('isLoggedIn', '1');
      toast.success('Login successful!', { toastId: 'login' });
    } catch (e) {
      console.error(e);
    }
  };

  if (isLoggedIn) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <PageMeta
        title="SignIn | Pfunzo Admin Template"
        description="This is Dashboard SignIn page for Pfunzo"
      />
      <div className="relative flex w-full h-screen px-4 py-6 overflow-hidden bg-white z-1 dark:bg-gray-900 sm:p-0">
        <div className="flex flex-col flex-1 p-6 rounded-2xl sm:rounded-none sm:border-0 sm:p-8">
          <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
            <div>
              <div className="mb-5 sm:mb-8">
                <h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
                  Sign In
                </h1>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Enter your email and password to sign in!
                </p>
              </div>
              <div>
                <form onSubmit={onSubmit}>
                  <div className="space-y-6">
                    <div>
                      <Label>
                        Email <span className="text-error-500">*</span>{' '}
                      </Label>
                      <Input
                        placeholder="info@gmail.com"
                        onChange={onChange}
                        name="email"
                        value={values.email}
                      />
                    </div>
                    <div>
                      <Label>
                        Password <span className="text-error-500">*</span>{' '}
                      </Label>
                      <div className="relative">
                        <Input
                          type={showPassword ? 'text' : 'password'}
                          placeholder="Enter your password"
                          onChange={onChange}
                          name="password"
                          value={values.password}
                        />
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                        >
                          {showPassword ? (
                            <EyeIcon className="fill-gray-500 dark:fill-gray-400" />
                          ) : (
                            <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400" />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Checkbox checked={isChecked} onChange={setIsChecked} />
                        <span className="block font-normal text-gray-700 text-theme-sm dark:text-gray-400">
                          Keep me logged in
                        </span>
                      </div>
                    </div>
                    <div>
                      <Button className="w-full" size="sm">
                        Sign in
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="relative items-center justify-center flex-1 hidden p-8 z-1 bg-brand-950 dark:bg-white/5 lg:flex">
          {/* <!-- ===== Common Grid Shape Start ===== --> */}
          <GridShape />
          <div className="flex flex-col items-center max-w-xs">
            <div className="block mb-4">
              <img src="./images/logo/pfunzo-logo-white.png" alt="Logo" />
            </div>
            <p className="text-center text-gray-400 dark:text-white/60">
              Admin Portal for Pfunzo
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
